// Component
import FormSlip from "./FormSlip";

const DepositFormSlipApp = ({ depositItems, isUserLoggedIn }) => {

    return <FormSlip depositItems={depositItems} isUserLoggedIn={isUserLoggedIn}></FormSlip>;
}

export default DepositFormSlipApp;